import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './EmailVerificationScreen.css';

export function EmailVerificationScreen(): React.ReactElement {
  const navigate = useNavigate();
  const { user, sendVerificationEmail, signOut } = useAuth();
  const [isSending, setIsSending] = useState(false);
  const [message, setMessage] = useState<string | null>(null);

  const handleResend = async () => {
    setIsSending(true);
    setMessage(null);
    try {
      await sendVerificationEmail();
      setMessage('Verification email sent! Check your inbox.');
    } catch (error) {
      setMessage('Failed to send email. Please try again.');
    } finally {
      setIsSending(false);
    }
  };

  const handleRefresh = () => {
    window.location.reload();
  };

  const handleLogout = async () => {
    try {
      await signOut();
      navigate('/login');
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  return (
    <div className="email-verification-screen">
      <div className="verification-container">
        <div className="verification-icon">📧</div>
        <h1>Verify Your Email</h1>
        <p className="verification-message">
          We've sent a verification email to:<br />
          <strong>{user?.email}</strong>
        </p>
        <p className="verification-instructions">
          Please check your inbox and click the verification link to continue.
        </p>
        
        {message && <p className="verification-status">{message}</p>}
        
        <div className="verification-actions">
          <button 
            onClick={handleResend} 
            disabled={isSending}
            className="btn-resend"
          >
            {isSending ? 'Sending...' : 'Resend Email'}
          </button>
          <button 
            onClick={handleRefresh}
            className="btn-refresh"
          >
            I've Verified - Refresh
          </button>
          <button 
            onClick={handleLogout}
            className="btn-logout"
          >
            Logout
          </button>
        </div>
      </div>
    </div>
  );
}

